import React from 'react';
import { Box } from '@wix/design-system';
const GalleryHeaderContainer = _ref => {
  let {
    className,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    className: className
  }, children);
};
export default GalleryHeaderContainer;
//# sourceMappingURL=GalleryHeaderContainer.js.map